import * as api from "api";
import moment from "moment";
import { getToken, tokenStorage, parseJwt } from "utils/authToken";

setInterval(async () => {
    const token = getToken();
    const claims = token && parseJwt(token);
    // Only full session tokens are refreshable; short-lived picker tokens and legacy tokens are not.
    if (!claims || !claims.exp || (claims.typ !== "user" && claims.typ !== "invite")) return;

    const expTime = moment.utc(claims.exp * 1000).subtract(10, 'minutes');
    if (moment.utc().isAfter(expTime)) {
        const storage = tokenStorage();
        try {
            const { data } = await api.refreshToken();
            // Write back to the storage the token came from, unless the session changed meanwhile.
            if (data && data.token && storage.getItem('user_token') === token) {
                storage.setItem('user_token', data.token);
            }
        } catch (error) {

        }
    }
}, 1000*60);
